var alertCheck = document.getElementById("top_alert");

if(alertCheck){
	var topHeight = "88px";
	var topMagic = "-88px";
	document.body.classList.add("pt88");
}else{
	var topHeight = "58px";
	var topMagic = "-58px";
	document.body.classList.add("pt58");
}

var controller = new ScrollMagic.Controller();

var scene = new ScrollMagic.Scene({triggerElement: "#child-nav", triggerHook: "onLeave", offset: topMagic}) // トリガー
		.setClassToggle("body", "fixed")
		.addTo(controller);

jQuery(function($){
	var $doc = $(document);
	var $win = $(window);
	var doc  = $('body');

	$("[data-modal]").on("click", function(){
		doc.addClass("modal-open")
		$("#modal-bg").fadeIn();
	});

	$("[data-close]").on("click", function(){
		$("#modal-bg").fadeOut();
		doc.removeClass("modal-open")
	});

	if(doc.hasClass('fixed')){

	}


});
